import "./App.css";
import pineconeLogo from "./images/pinecone.png";
import stressBallLogo from "./images/stressBallLogo.png";
import inspoLogo from "./images/inspoLogo.png";

// Arrow icon for links
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

function App() {
  return (
    <div className="app">
      {/* Header */}
      <header className="header">
        <div className="header-content">
          <a href="/" className="logo">
            <img src={pineconeLogo} alt="Pinecone Labs" className="logo-img" />
            Pinecone Labs
          </a>
          <nav className="nav">
            <a href="#home" className="nav-link">
              Home
            </a>
            <a href="#products" className="nav-link">
              Products
            </a>
            <a href="#contact" className="nav-link">
              Contact
            </a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="hero-badge-dot"></span>
            Building apps that matter
          </div>
          <h1 className="hero-title">
            Apps That Help You <span className="hero-title-accent">Thrive</span>
          </h1>
          <p className="hero-subtitle">
            We build thoughtfully designed mobile apps for productivity,
            wellness, and everyday life. Simple tools that make a real
            difference.
          </p>
          <div className="stats">
            <div className="stat">
              <div className="stat-value">5+</div>
              <div className="stat-label">Apps</div>
            </div>
            <div className="stat">
              <div className="stat-value">500K+</div>
              <div className="stat-label">Downloads</div>
            </div>
            <div className="stat">
              <div className="stat-value">4.9★</div>
              <div className="stat-label">Average Rating</div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="products">
        <div className="section-header">
          <div className="section-label">Our Products</div>
          <h2 className="section-title">Apps We've Built</h2>
        </div>
        <div className="products-grid">
          {/* Stress Ball Card */}
          <div className="product-card">
            <div className="product-image stress-ball">
              <img
                src={stressBallLogo}
                alt="Stress Ball"
                className="product-logo"
              />
            </div>
            <div className="product-content">
              <div className="product-category">Wellness</div>
              <h3 className="product-name">Stress Ball</h3>
              <p className="product-description">
                Interactive exercises, virtual fidgets, and calming tools to
                help you manage anxiety and find relaxation whenever you need
                it.
              </p>
              <div className="product-features">
                <span className="product-feature">Breathing Exercises</span>
                <span className="product-feature">Fidget Toys</span>
                <span className="product-feature">ASMR Sounds</span>
                <span className="product-feature">Coloring</span>
                <span className="product-feature">Journaling</span>
              </div>
              <a
                href="https://stressballapp.com"
                className="product-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More <ArrowIcon />
              </a>
            </div>
          </div>

          {/* Inspo Card */}
          <div className="product-card">
            <div className="product-image inspo">
              <img src={inspoLogo} alt="Inspo" className="product-logo" />
            </div>
            <div className="product-content">
              <div className="product-category">Lifestyle</div>
              <h3 className="product-name">Inspo</h3>
              <p className="product-description">
                Save recipe videos from Instagram, TikTok, and more. AI extracts
                ingredients, steps, and nutrition info automatically.
              </p>
              <div className="product-features">
                <span className="product-feature">AI Extraction</span>
                <span className="product-feature">Smart Organization</span>
                <span className="product-feature">Cooking Mode</span>
                <span className="product-feature">PDF Export</span>
              </div>
              <a
                href="https://insporecipeapp.netlify.app"
                className="product-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More <ArrowIcon />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <img
              src={pineconeLogo}
              alt="Pinecone Labs"
              className="footer-logo"
            />
            Pinecone Labs
          </div>
          <div className="footer-links">
            <a href="#home" className="footer-link">
              Home
            </a>
            <a href="#products" className="footer-link">
              Products
            </a>
            <a href="mailto:hello@pineconelabs.com" className="footer-link">
              Contact
            </a>
          </div>
          <div className="footer-copyright">
            © {new Date().getFullYear()} Pinecone Labs LLC. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
